import { VoceGuidaCompilazioneRequestTesto } from '@framework/api-client';
import {
  StyledRteHtmlTextGuide,
  renderRichTextAdvancedNodes,
} from '@framework/engine';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const GuideTextDiv = styled.div`
  &&& {
    ${StyledRteHtmlTextGuide}
  }
`;

export interface IGuideTextStyledProps {
  text?: VoceGuidaCompilazioneRequestTesto[] | null;
}

/**
 * Una singola voce di guida
 */
export function GuideTextStyled(props: IGuideTextStyledProps) {
  const renderedTexts = useMemo(
    () =>
      props.text?.map(element => renderRichTextAdvancedNodes(element?.text)),
    [props.text],
  );

  if (!props.text || !renderedTexts || isEmpty(props.text)) return null;

  return (
    <GuideTextDiv>
      {renderedTexts.map((renderedText, i) => (
        <span key={i}>{renderedText}</span>
      ))}
    </GuideTextDiv>
  );
}
